import EuroSymbol from '@mui/icons-material/EuroSymbol';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EuroIcon(props: FixMe) {
  return <EuroSymbol {...props} />;
}

export default EuroIcon;
